module.exports = __webpack_public_path__ + "img/pantalla-1-3-2.1461e906.png";